export default "__VITE_ASSET__CMn6Brj8__"